import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link as RouterLink } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import MissionCard from "../Missions/MissionCard";
import missions from "../../content/missions.json";

const OurMissions = () => {
  const theme = useTheme();

  return (
    <Box
      component="section"
      sx={{
        px: { xs: 2, sm: 4 },
        py: { xs: 6, md: 9 },
        bgcolor: "background.default",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 1180, mx: "auto" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
          <Box>
            <Typography
              variant="overline"
              color={theme.palette.primary.main}
              sx={{ fontWeight: 900 }}
            >
              Field work
            </Typography>
            <Typography
              variant="h2"
              color={theme.palette.primary.main}
              sx={{ fontSize: { xs: "2rem", md: "3rem" }, lineHeight: 1.05 }}
            >
              Our Missions
            </Typography>
          </Box>
          <Button
            endIcon={<ArrowForwardIcon />}
            component={RouterLink}
            to="/missions"
            sx={{ display: { xs: "none", sm: "inline-flex" }, alignSelf: "end" }}
          >
            View all missions
          </Button>
        </Box>
        <Typography
          sx={{
            mt: 1.5,
            maxWidth: 720,
            color: "text.secondary",
            fontSize: { xs: "1rem", md: "1.08rem" },
            lineHeight: 1.7,
          }}
        >
          Each visit combines direct patient care with practical teaching, so the
          impact continues after the travelling team returns home.
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(3, minmax(0, 1fr))",
            },
            alignItems: "stretch",
            pt: 3,
            gap: 2.5,
          }}
        >
          {missions.map((mission) => (
            <MissionCard key={`${mission.date}-${mission.title}`} {...mission} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default OurMissions;
